// Activate functionality restricted behind Iubenda consents
//
// This functions is invoked by Iubenda,
// add this to Iubenda _iub.csConfiguration:
//
// {
//   [...]
// Bisogna aggiungere questo codice direttamente in iubenda e non su tag manager
//   "callback": {
//          "onPreferenceExpressed":function (event) {
//                  window.iubendaConsentExpressed && window.iubendaConsentExpressed(event);
//                  document.addEventListener('DOMContentLoaded', function () { 
//                          iubendaConsentExpressed(event) 
//                  }); 
//           }
//   },
//   [...]
// }
//

import $ from 'jquery'
import Component from  "../models/Component"


export default class GmultimapIubenda extends Component {
	static _initializers = [];

	constructor(element, context) {
		super(element, context);

		this.markers = [];
		this.mapStyle = [{
				"featureType": "all",
				"elementType": "labels.text",
				"stylers": [{
					"color": "#878787"
				}]
			},
			{
				"featureType": "all",
				"elementType": "labels.text.stroke",
				"stylers": [{
					"visibility": "off"
				}]
			},
			{
				"featureType": "landscape",
				"elementType": "all",
				"stylers": [{
					"color": "#f9f5ed"
				}]
			},
			{
				"featureType": "road.highway",
				"elementType": "all",
				"stylers": [{
					"color": "#f5f5f5"
				}]
			},
			{
				"featureType": "road.highway",
				"elementType": "geometry.stroke",
				"stylers": [{
					"color": "#c9c9c9"
				}]
			},
			{
				"featureType": "water",
				"elementType": "all",
				"stylers": [{
					"color": "#aee0f4"
				}]
			}
		];

		GmultimapIubenda._initializers.push(() => {
			this.initGoogleMaps();
		});

		this.makers = this.getData('markers');

		this.checkAndLoadGoogleMaps();
	}

checkAndLoadGoogleMaps() {
    if (window.iubendaConsent && window.iubendaConsent.purposes[3]) {
		console.log('caricamento mappa');
		

        this.loadGoogleMaps();
    } else {
        // Seleziona il div esistente
        const consentMessage = document.getElementById('cookie-message-accept');
		const messageText = "accetta"
        
        if (consentMessage) {
			const messageText = window._gTheme_.mapConsentMessage || 'To view the map, accept cookies.'; // Aggiunto un fallback per sicurezza

            consentMessage.innerHTML = `
                <p style="margin: 0 0 8px; text-align:center;">${messageText}</p>
            `;
			consentMessage.style.display = 'block';
        }

        // Ascolta gli eventi di consenso
        window.iubendaConsentExpressed = (event) => {
			console.log('cambio consenso');
            if (event.purposes[3]) {
				console.log('Accettati cookie');
                this.loadGoogleMaps();

                // Nascondi il messaggio se il consenso è stato dato
                if (consentMessage) {
                    consentMessage.style.display = 'none';
                }
            }
        };
    }
}



	loadGoogleMaps() {
		if (!window.initGoogleMaps) {
			window.initGoogleMaps = () => {
				GmultimapIubenda.initAllGoogleMaps();
			};
			const scriptSrc =
				'https://maps.googleapis.com/maps/api/js?key=' +
				window._gTheme_.google_maps_api_key +
				'&callback=initGoogleMaps';
			const script = document.createElement('script');
			script.type = 'text/javascript';
			script.src = scriptSrc;
			document.body.appendChild(script);
		}
	}

	initGoogleMaps() {
		this.map = new google.maps.Map(this.element.get(0), {
			zoom: 1,
			minZoom: 3,
			center: {
				lat: 45.12345,
				lng: 9.12345
			},
			scrollwheel: false,
			mapTypeControl: false,
			fullscreenControl: false,
			streetViewControl: false,
			rotateControl: false,
			styles: this.mapStyle,
		});


		this.addMarkers(this.makers);
		this.element.parent().removeClass('loading');
	}

	addMarkers(markers) {
		markers.forEach((marker) => {
			const position = {
				lat: marker.lat,
				lng: marker.lng
			};

			const googleMarker = new google.maps.Marker({
				position: position,
				map: this.map,
				url: marker.url,
				icon: {
					url: window.location.origin + '/wp-content/uploads/2024/12/pin-maps.png',
					scaledSize: new google.maps.Size(30, 38),
				},
			});

			const infoWindowContent =
				'<div class="popup-marker"><h3>' +
				marker.title +
				'</h3><p>' +
				marker.description +
				'</p></div>';

			const infoWindow = new google.maps.InfoWindow({
				content: infoWindowContent,
			});

			googleMarker.addListener('click', () => {
				infoWindow.open(this.map, googleMarker);
			});

			this.markers.push(googleMarker);
		});
	}

	static initAllGoogleMaps() {
		GmultimapIubenda._initializers.forEach(function (initializer) {
			initializer();
		});
	}
}
